import { initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs } from "firebase/firestore";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBJ6izqMUEi4K246QJmPz6aAmQbhbeD0Sc",
  authDomain: "emergency-app-79ce2.firebaseapp.com",
  projectId: "emergency-app-79ce2",
  storageBucket: "emergency-app-79ce2.firebasestorage.app",
  messagingSenderId: "562422431604",
  appId: "1:562422431604:android:b99f62c943561c40edb621",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db, collection, getDocs };
